import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "@/components/layout/Navbar";

const Layout = ({ children }) => (
  <div className="flex min-h-screen bg-slate-50">
    <div className="relative hidden w-1/2 flex-col justify-between overflow-hidden bg-slate-900 p-14 text-white noise lg:flex">
      <div className="[&_span]:text-white [&_a>span:last-child>span]:text-blue-400"><Logo /></div>
      <div>
        <h1 className="text-4xl font-extrabold leading-tight tracking-tight lg:text-5xl">La tua identità aziendale,<br />in un solo tocco.</h1>
        <p className="mt-6 max-w-md text-slate-400">Crea, aggiorna e condividi la scheda digitale della tua impresa via link, QR code e NFC.</p>
      </div>
      <p className="text-sm text-slate-500">carta.taptolink.it</p>
    </div>
    <div className="flex flex-1 flex-col items-center justify-center gap-8 px-4 py-12">
      <div className="lg:hidden"><Logo /></div>
      {children}
    </div>
  </div>
);

export const SignInPage = () => (
  <Layout><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></Layout>
);

export const SignUpPage = () => (
  <Layout><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></Layout>
);
